module.exports = __webpack_public_path__ + "img/wibo-13.a559f30b.jpg";